import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import logo from "../assets/logo.png";
import { Link } from 'react-router-dom';


const Footer = () => {
    return (
        <>
            <footer className="footer text-white pt-4 pb-2">
                <Container>
                    {/* Main content */}
                    <Row className="align-items-start text-center text-md-start">
                        {/* Left */}
                        <Col md={3} className="mb-4 mb-md-0">
                            <img src={logo} alt="Company Logo" className="footer-logo mb-2" />
                            <p className="mb-3">Get quick, flexible, and affordable loans tailored for women.</p>
                            <div className="social-icons mb-3">
                                <a href="#"><FaFacebookF size={22} /></a>
                                <a href="#"><FaTwitter size={22} /></a>
                                <a href="#"><FaInstagram size={22} /></a>
                                <a href="#"><FaLinkedin size={22} /></a>
                            </div>
                        </Col>

                        {/* Middle */}
                        <Col md={3} className="mb-4 mb-md-0">
                            <h5 className="mb-3">Quick Link</h5>
                            <ul className="footer-links list-unstyled">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/services">Our Services</Link></li>
                                <li><Link to="/loan-repayment">Loan Repayment</Link></li>
                                <li><Link to="/contact">Contact Us</Link></li>
                            </ul>
                        </Col>

                        {/* Right */}
                        <Col md={2} className="mb-4 mb-md-0">
                            <h5 className="mb-3">Services</h5>
                            <ul className="footer-links list-unstyled">
                                <li><a>Personal Loans</a></li>
                                <li><a>Loan Against Property</a></li>
                                <li><a>Business Loans</a></li>
                                <li><a>Housing & Consumer Loans</a></li>
                            </ul>
                        </Col>

                        {/* end */}
                        <Col md={4} className="text-center">
                            <h5 className="mb-3">Contact Us</h5>
                            <p>
                                {/* C/o Shri Rakesh Chandra<br /> */}
                                {/* 265/9A, */}
                                 Mumfordganj, Housing Scheme<br />
                                Shanti Nagar, Allahabad, Uttar Pradesh<br />
                                India - 211002<br />
                                {/* <strong>Contact No:</strong> 8400877778<br /> */}
                                <strong>Email:</strong> contact@surbhifinances.org
                            </p>
                        </Col>

                    </Row>

                    {/* Bottom */}
                    <Row className="pt-4">
                        <Col className="text-center">
                            <small>© {new Date().getFullYear()} SURBHI FINANCES. All rights reserved.</small>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    )
}

export default Footer